import React from "react";
import { Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import { ASSET_NAME } from "../../../../assets";

const PixiButtonClose = ({ onClick, windowSize }) => {
  const closeTexture = PIXI.Assets.get(ASSET_NAME.icon_close_menu);

  if (!closeTexture) {
    return null; // Don't render if texture not loaded
  }

  // Calculate responsive button size (max 101px, 17% of window width)
  const closeButtonSize = Math.min(101, windowSize.width * 0.13);

  // Position within groove - inset from corner by buttonSize/3.1 (negative moves inward)
  const grooveInset = -(closeButtonSize / 4);

  // Position relative to window center, accounting for groove alignment
  const closeX = 0 + windowSize.width / 2 - grooveInset - closeButtonSize / 3.5;
  const closeY =
    0 - (windowSize.height / 2 - grooveInset - closeButtonSize / 3.5);

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <Sprite
      texture={closeTexture}
      name="close_button"
      anchor={0.5}
      x={closeX}
      y={closeY}
      width={closeButtonSize}
      height={closeButtonSize}
      eventMode="static"
      cursor="pointer"
      onpointertap={handleClick}
    />
  );
};

export default PixiButtonClose;
